/** Must be in sync with fleet backend equivalent enum  */
export enum ERoutes {
	search = '/search',
	home = '/',
	trips = '/trips',
	tripInfo = '/trip-info',
	any = '*',
	tel = 'tel:',
	blank = '_blank',
	noopener = 'noopener,noreferrer',
}
